import { render } from "./CommentItem.vue?vue&type=template&id=7e87aa66"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=7e87aa66&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__